import {APIDirectory , HTTP} from '../../rest';

export const GET_SUBJECT_MASTER_DATA_IN_PROGRESS = "GET_SUBJECT_MASTER_DATA_IN_PROGRESS"

export const GET_SUBJECT_MASTER_DATA_COMPLETE = "GET_SUBJECT_MASTER_DATA_COMPLETE"

export const SAVE_SUBJECTS_IN_PROGRESS = "SAVE_SUBJECTS_IN_PROGRESS"

export const SAVE_SUBJECTS_COMPLETE = "SAVE_SUBJECTS_COMPLETE"

export const GET_SUBJECTS_IN_PROGRESS = "GET_SUBJECTS_IN_PROGRESS"

export const GET_SUBJECTS_COMPLETE = "GET_SUBJECTS_COMPLETE"

export const getSubjectMasterDataInProgress = () => {
    return{
    type:GET_SUBJECT_MASTER_DATA_IN_PROGRESS
}
}

export const getSubjectMasterDataComplete = (data) => {
    return{
    type:GET_SUBJECT_MASTER_DATA_COMPLETE,
    data:data
}
}

export const saveSubjectInProgress = () => {
    return{
        type:SAVE_SUBJECTS_IN_PROGRESS
    }
}

export const saveSubjectsComplete = (data) => {
    return{
        type:SAVE_SUBJECTS_COMPLETE,
        data:data
    }
}
export const getSubjectsInProgress = () => {
    return {
        type:GET_SUBJECTS_IN_PROGRESS
    }
}

export const getSubjectsComplete = (data) => {
    return {
        type:GET_SUBJECTS_COMPLETE,
        data:data
    }
}

export const saveSubjectInformation = (school,subjectList) => {
    return async dispatch => {
        try{
        dispatch(saveSubjectInProgress());
        let url = APIDirectory.getUpdateSchoolURL(1,school._id);
        let saveSubjectInformationResult = await  HTTP.PUT(url ,JSON.stringify(school))
        dispatch(saveSubjectsComplete(saveSubjectInformationResult));
        return saveSubjectInformationResult
    }catch(error){
        return[];
    }
  }
}

export const getSubjects = (owenerId,schoolId) =>
{
  
    return async dispatch => {
        try {
            dispatch(getSubjectsInProgress());
            let url = APIDirectory.getSubjects(owenerId,schoolId);
            let subjectList = await HTTP.GET(url);       
            dispatch(getSubjectsComplete(subjectList));
            return subjectList;
        }catch (error) {
                return [];
            }
    };
};
export const getSubjectMasterData = () =>{
    return async dispatch => {
        try{
            dispatch(getSubjectMasterDataInProgress());
            let url = APIDirectory.getSubjectMasterData();
            let getSubjectMasterDataResult = await HTTP.GET(url);
            dispatch(getSubjectMasterDataComplete(getSubjectMasterDataResult));
            return getSubjectMasterDataResult
        }catch(error){
            return [];
        }
    };
};